<div class="flex flex-col h-full">

  <!-- Header -->
  <div class="flex items-start justify-between border-b border-n30 px-6 py-4 flex-shrink-0">
    <p class="font-semibold text-n900 text-lg leading-tight">Change Password</p>
    <button (click)="close()" class="text-n400 hover:text-n700 transition-colors mt-0.5 ml-4 flex-shrink-0">
      <i class="ph ph-x text-xl"></i>
    </button>
  </div>

  <!-- Body -->
  <div class="flex-1 overflow-y-auto px-6 py-5">
    <form novalidate (keyup.enter)="save()" [formGroup]="passwordGroup" class="space-y-4">
      <div class="space-y-1.5">
        <label class="block text-xs font-semibold text-n400 uppercase tracking-wide">Password *</label>
        <input type="password" autocomplete="off" placeholder="Enter Password" [formControl]="passwordControl" required
          class="w-full rounded-xl border border-n30 bg-n10 px-4 py-2.5 text-sm outline-none focus:border-b300 transition-colors" />
        <app-form-error [control]="passwordControl" [fieldName]="'Password'"></app-form-error>
      </div>
      <div class="space-y-1.5">
        <label class="block text-xs font-semibold text-n400 uppercase tracking-wide">Confirm Password *</label>
        <input type="password" autocomplete="off" placeholder="Enter Confirm Password" [formControl]="confirmPasswordControl" required
          class="w-full rounded-xl border border-n30 bg-n10 px-4 py-2.5 text-sm outline-none focus:border-b300 transition-colors" />
        <app-form-error [control]="confirmPasswordControl" [fieldName]="'Confirm Password'"></app-form-error>
      </div>
    </form>
  </div>

  <!-- Footer -->
  <div class="flex gap-3 border-t border-n30 px-6 py-4 flex-shrink-0">
    <button (click)="close()" class="flex-1 py-2.5 rounded-xl border border-n30 text-n500 text-sm font-medium hover:bg-n10 transition-colors">Cancel</button>
    <button (click)="save()" [disabled]="isSaving || !passwordGroup.valid"
      class="flex-1 py-2.5 rounded-xl bg-b300 text-white text-sm font-medium hover:bg-b400 transition-colors disabled:opacity-60">
      <i *ngIf="isSaving" class="ph ph-circle-notch animate-spin mr-1"></i>
      {{ isSaving ? 'Saving...' : 'Save' }}
    </button>
  </div>

</div>
